import { render, staticRenderFns } from "./IdentityErrorModal.vue?vue&type=template&id=157e7933&"
import script from "./IdentityErrorModal.vue?vue&type=script&lang=js&"
export * from "./IdentityErrorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports